import { initFormLocale } from "./form-locale";

export const initCore = () => {
  // Init form locales
  initFormLocale();
};
